<header class="name-header">
  <h2 *ngIf="user">{{user.fullname}}</h2>
</header>
<section class="overview">
  <div class="overview-item">
    <span class="overview-label">{{'WEEK' | translate}}</span>
    <span class="overview-number">{{ currWeek }}</span>
  </div>
  <div class="overview-item">
    <span class="overview-label">{{'DAY' | translate}}</span>
    <span class="overview-number">{{ currDay }}</span>
  </div>
</section>
<section class="table-wrapper">
  <table [cellSpacing]="0">
    <thead>
      <tr>
        <th>{{'DAY' | translate}}</th>
        <th>{{'FINISHED' | translate}}</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngIf="!this.moodSnapshots || !this.moodSnapshots[0] || this.moodSnapshots[0].day !== fullDay">
        <td>{{convertDayToDisplay(fullDay)}}</td>
        <td></td>
      </tr>
      <tr *ngFor="let s of moodSnapshots">
        <td>{{convertDayToDisplay(s.day)}}</td>
        <td>{{s.date | date:'dd-MM-yyyy'}}</td>
      </tr>
    </tbody>
  </table>
</section>
